import React, { useState } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { TEMPLATE_MESSAGES as M, VARIABLE_NAME_TOKEN } from '../templateMessages'
import { TipTapEditor } from '../../shared/TipTapEditor'

interface HTMLEditorProps {
  value: string
  onChange: (value: string) => void
  height?: number
  variables?: string[]
  onEditorReady?: (editor: any) => void
  mode?: 'standalone' | 'embedded'
}

export const HTMLEditor: React.FC<HTMLEditorProps> = ({
  value,
  onChange,
  height = 400,
  variables = [],
  onEditorReady,
  mode = 'standalone',
}) => {
  const intl = useIntl()
  const [showCode, setShowCode] = useState(false)
  const isEmbedded = mode === 'embedded'

  return (
    <div>
      <div className={`d-flex justify-content-between align-items-center ${isEmbedded ? 'px-4 py-3 border-bottom bg-light' : 'mb-2'}`}>
        {!isEmbedded && <label className='form-label mb-0'><FormattedMessage {...M.htmlEditorLabel} /></label>}
        {isEmbedded && <div className='fw-semibold'><FormattedMessage {...M.htmlEditorMode} /></div>}
        <button
          type='button'
          className='btn btn-sm btn-outline-secondary'
          onClick={() => setShowCode(!showCode)}
        >
          <i className={`bi ${showCode ? 'bi-eye' : 'bi-code-slash'} me-1`}></i>
          {intl.formatMessage(showCode ? M.htmlEditorViewCode : M.htmlEditorVisual)}
        </button>
      </div>

      {showCode ? (
        <>
          <textarea
            className={`form-control font-monospace ${isEmbedded ? 'border-0 rounded-0' : ''}`}
            style={{ minHeight: `${height}px`, fontSize: '13px' }}
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
          <div className={`form-text ${isEmbedded ? 'px-4 py-3 mt-0 border-top' : 'mt-2'}`}>
            <i className='bi bi-info-circle me-1'></i>
            <FormattedMessage {...M.htmlEditorRawHint} />
          </div>
        </>
      ) : (
        <>
          <TipTapEditor value={value} onChange={onChange} height={height} variables={variables} onEditorReady={onEditorReady} />
          <div className={`form-text ${isEmbedded ? 'px-4 py-3 mt-0 border-top' : 'mt-2'}`}>
            <i className='bi bi-info-circle me-1'></i>
            <FormattedMessage {...M.htmlEditorToolbarHint} />
            <br />
            <FormattedMessage
              {...M.htmlEditorVariablesHint}
              values={{ variable: <code>{VARIABLE_NAME_TOKEN}</code> }}
            />
          </div>
        </>
      )}
    </div>
  )
}
